import * as Sentry from '@sentry/nextjs';
import { GetGoalTOCParamsModel, GoalTOCModel } from 'lib/models/goalTocs';
import { useCallback } from 'react';
import { useImprvApi } from './useImprvApi';
/**
 * Custom hook for managing Goal TOC operations
 */
export const useGoalTOCService = () => {
  const imprvApi = useImprvApi();

  const getToc = useCallback(
    async (params: GetGoalTOCParamsModel): Promise<GoalTOCModel> => {
      try {
        return await imprvApi.getGoalTOC(params);
      } catch (error) {
        Sentry.captureException(error);
        throw error;
      }
    },
    [imprvApi]
  );

  return { getToc };
};
